(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyRule', CompanyRule);

    CompanyRule.$inject = ['$resource'];

    function CompanyRule($resource) {
        var resourceUrl = 'api/company-rules/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
